import React from "react";

const CartIcon = ({ width, height, fill }) => (
  <svg
    className="Icon__icon-svg___1yoHe"
    viewBox="0 0 23 18"
    width={width}
    height={height}
    fill={fill}
  >
    <path
      d="M8.3 16.24a1.447 1.447 0 1 1 2.894-.002 1.447 1.447 0 0 1-2.893.001M15.538 16.24a1.447 1.447 0 1 1 2.894 0 1.447 1.447 0 0 1-2.894 0M19.7 12.318H6.326L4.301 2.474H.773v-2h5.158l2.027 9.844h10.368l2.647-6.887 1.868.72z"
      fillRule="evenodd"
    />
  </svg>
);

export default CartIcon;



// WEBPACK FOOTER //
// ./src/images/cartIcon.js